import UIDs from "../../../../UIDs";

const uid = UIDs.screens.learn.addcomment;

const ActionTypes = {

    ADD_COMMENT_ASYNC: `${uid}.addCommentAsync`,
    ADD_COMMENT_SUCCESS: `${uid}.addCommentSuccess`,
    ADD_COMMENT_FAILURE: `${uid}.addCommentFailure`,

    CHANGE_STATE: `${uid}.changeState`,
};

export { ActionTypes };